import axios from "./axios";
import { errorToast, successToast } from "../shared/Toast";

// Admin CRUD for Short Links (Diawi-style app-distribution links + QR + analytics).
// Backend responses follow the { isError, message, data } envelope. Each link
// record already carries shortUrl / downloadUrl / qrUrl built server-side.

const fetchShortLinks = async (params = {}) => {
  try {
    const response = await axios.get("/api/short-links", { params });
    const responseData = response?.data;
    if (responseData?.isError === false) {
      return responseData?.data || { rows: [], totalCount: 0 };
    }
    errorToast(responseData?.message ?? "Error loading short links");
    return { rows: [], totalCount: 0 };
  } catch (error) {
    console.error("Error fetching short links:", error);
    errorToast(error?.response?.data?.message ?? "Error loading short links");
    return { rows: [], totalCount: 0 };
  }
};

const getShortLink = async (id) => {
  try {
    const response = await axios.get(`/api/short-links/${id}`);
    const responseData = response?.data;
    if (responseData?.isError === false) {
      return responseData?.data;
    }
    errorToast(responseData?.message ?? "Error loading short link");
    return null;
  } catch (error) {
    console.error("Error fetching short link:", error);
    errorToast(error?.response?.data?.message ?? "Error loading short link");
    return null;
  }
};

const createShortLink = async (payload) => {
  try {
    const response = await axios.post("/api/short-links", payload);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "Short link created");
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error creating short link");
    return null;
  } catch (error) {
    console.error("Error creating short link:", error);
    errorToast(error?.response?.data?.message ?? "Error creating short link");
    return null;
  }
};

const updateShortLink = async (id, payload) => {
  try {
    const response = await axios.put(`/api/short-links/${id}`, payload);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "Short link updated");
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating short link");
    return null;
  } catch (error) {
    console.error("Error updating short link:", error);
    errorToast(error?.response?.data?.message ?? "Error updating short link");
    return null;
  }
};

const deleteShortLink = async (id) => {
  try {
    const response = await axios.delete(`/api/short-links/${id}`);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "Short link deleted");
      return true;
    }
    errorToast(response?.data?.message ?? "Error deleting short link");
    return false;
  } catch (error) {
    console.error("Error deleting short link:", error);
    errorToast(error?.response?.data?.message ?? "Error deleting short link");
    return false;
  }
};

// Merchant options for the create/edit dropdown (admin sees all).
const fetchMerchants = async () => {
  try {
    const response = await axios.get("/api/merchant/getMerchantsList");
    if (response?.data?.isError === false) {
      return response?.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching merchants:", error);
    return [];
  }
};

export {
  fetchShortLinks,
  getShortLink,
  createShortLink,
  updateShortLink,
  deleteShortLink,
  fetchMerchants,
};
